import { createSelector } from 'reselect';

const selectComments = (state) => state.comments;

const selectCommentsData = createSelector(
	selectComments,
	(comments) => comments?.newComments
);

const isLoadingComments = createSelector(
	selectComments,
	(comments) => comments?.isLoading
);

const selectCommentReply = createSelector(
	selectComments,
	(comments) => comments?.reply
);

const commentsSelector = {
	selectComments,
	selectCommentsData,
	isLoadingComments,
	selectCommentReply,
};

export default commentsSelector;
